export { TableModule, FiltersInModalBreakpoint } from "./table-module";
